export default "__VITE_ASSET__Dq6nydjk__"